export const Details = {
    LOAD_SOURCE_DETAIL: "LOAD_SOURCE_DETAIL",
    CLEAR_SOURCE_DETAILS: "CLEAR_CURRENT_SOURCE_DETAIL",
    DELETE_SOURCE_WARNING: "DELETE_WARNING_FOR_SOURCE",
}
